import { createApp, ref } from 'vue'
import MToast from './'
import { Toast, ToastShowOptions } from '../types'

const toasts = ref<Toast[]>([])
let app: any

export default function useToast() {
    const renderComponent = (toasts: any) => {
        if (!app) {
            const oldContainer = document.querySelector('.toast-container')
            if (oldContainer) oldContainer.remove()

            const container = document.createElement('div')
            container.classList.add('toast-container')
            const root = document.body.appendChild(container)
            app = createApp(MToast, { toasts: toasts.value, pause, resume, hide })
            app.mount(root)
        }
    }

    const remove = (id: number) => {
        const index = toasts.value.findIndex((toast) => toast.id === id)
        if (index !== -1) {
            if (toasts.value[index].timeoutId) clearTimeout(toasts.value[index].timeoutId)
            toasts.value.splice(index, 1)
        }
    }

    const schedule = (toast: Toast) => {
        if (toast.timeoutId) clearTimeout(toast.timeoutId)
        toast.timeoutId = undefined

        if (toast.timeout) {
            // @ts-ignore
            toast.timeoutId = setTimeout(() => remove(toast.id), toast.timeout)
        }
    }

    const show = (options?: ToastShowOptions | string) => {
        const toast = new Toast(
            typeof options === 'string'
                ? { label: options, timeout: 4000 }
                : { ...options, timeout: options?.timeout ?? 4000 }
        )

        toasts.value.push(toast)
        // Schedule on the reactive instance, so a later update can clear the same timeout
        schedule(toasts.value[toasts.value.length - 1])

        if (!app) renderComponent(toasts)

        return toast.id
    }

    const update = (id: number, options: Partial<ToastShowOptions>) => {
        const toast = toasts.value.find((toast) => toast.id === id)
        if (!toast) return

        Object.assign(toast, options)
        if (options.timeout !== undefined) schedule(toast)
    }

    const pause = () => {
        toasts.value.forEach((toast) => {
            if (toast.timeoutId) clearTimeout(toast.timeoutId)
        })
    }

    const resume = () => {
        toasts.value.forEach((toast) => schedule(toast))
    }

    const hide = (id?: number) => {
        if (id) {
            remove(id)
        } else if (toasts.value.length) {
            remove(toasts.value[0].id)
        }
    }

    return {
        show,
        update,
        hide,
    }
}
